import BaseComponent from "../../BaseComponent";

export default class TopicsTagAssignment extends BaseComponent {

    private readonly url: string;

    private name: string = '';
    private color: string = '';

    private sending = false;

    constructor($component, context) {
        super($component, context);

        this.url = this.$component.data('url');
    }

    init() {
        this.$component.on('click', e => e.stopPropagation());

        this.$component.find('input[type="text"]').on('input', e => {
            this.name = e.target.value;
        });

        this.$component.find('[data-color-value]').on('click', e => {
            this.color = e.target.dataset.colorValue;
            this.$component.find('[data-color-value]').each((_, el) => el.classList.remove('border-black'))
            e.target.classList.add('border-black');
        });

        this.$component.find('button').on('click', e => {
            e.preventDefault();
            e.stopPropagation();

            if (this.sending) {
                return;
            }

            this.sending = true;
            this.context.naja.makeRequest('POST', this.url, {
                name: this.name,
                color: this.color
            }).finally(() => {
                this.sending = false;
            })
        });
    }
}
